<!-- name-only mode: just the name (thieme prefix stripped), no pill -->
<span
  *ngIf="mode === 'name'"
  class="origin-name origin-name-only"
  #nameOnlyEl
  container="body"
  [ngbTooltip]="displayName"
  #nameOnlyTooltip="ngbTooltip"
  triggers="manual"
  (mouseenter)="openTitleTooltip(nameOnlyEl, nameOnlyTooltip)"
  (mouseleave)="nameOnlyTooltip.close()"
>{{displayName}}</span>

<!-- pill modes without the thieme license: plain title, no pill -->
<ng-container *ngIf="mode !== 'badge' && mode !== 'name' && !licensed">{{title}}</ng-container>

<span class="qo" [class.qo-inline]="mode === 'inline'" *ngIf="mode !== 'name' && licensed">
  <!-- thieme: pill always links to the catalog -->
  <a
    *ngIf="isThieme"
    class="badge origin-pill grid-link badge-primary"
    [routerLink]="catalogLink"
    [queryParams]="catalogQueryParams"
  >Thieme<ng-container *ngIf="bogenCode"> &middot; {{bogenCode}}</ng-container><ng-container *ngIf="flagCode"> &middot; <span class="flag-icon flag-icon-{{flagCode}}"></span></ng-container></a>

  <!-- mymedax: pill links to the editor only when editable -->
  <a
    *ngIf="!isThieme && editorLink"
    class="badge origin-pill grid-link badge-secondary"
    [routerLink]="editorLink"
  >myMedax</a>
  <span
    *ngIf="!isThieme && !editorLink"
    class="badge origin-pill badge-secondary"
  >myMedax</span>

  <span
    class="origin-name"
    *ngIf="mode !== 'badge'"
    #nameEl
    container="body"
    [ngbTooltip]="bogenName"
    #nameTooltip="ngbTooltip"
    triggers="manual"
    (mouseenter)="openTitleTooltip(nameEl, nameTooltip)"
    (mouseleave)="nameTooltip.close()"
  >{{bogenName}}</span>
</span>
